module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pshou15-9dddb6e9c828be1c91790676134d608a.jpg";